export const BookingFilters = Object.freeze({
  default: {
    id: 0,
    title: 'topFilterBar.filter.title',
    icon: 'mdi-filter-outline',
  },
  status: {
    id: 1,
    title: 'bookingList.headerName.status',
    icon: 'mdi-checkbox-marked-circle-outline',
    name: 'status',
    itemsProp: 'statusItems',
    localSelectedProp: 'localSelectedStatuses',
    valueKey: 'value',
    labelKey: 'label',
  },
  educator: {
    id: 2,
    title: 'bookingList.headerName.educator',
    icon: 'mdi-account-outline',
    name: 'educator',
    itemsProp: 'educators',
    localSelectedProp: 'localSelectedEducators',
    valueKey: 'candidateId',
    labelKey: ['firstName', 'lastName'],
  },
  classification: {
    id: 3,
    title: 'bookingList.headerName.classification',
    icon: 'mdi-briefcase-outline',
    name: 'classification',
    itemsProp: 'classifications',
    localSelectedProp: 'localSelectedClassifications',
    valueKey: 'classificationId',
    labelKey: 'classification',
  },
  location: {
    id: 4,
    title: 'bookingList.headerName.location',
    icon: 'mdi-map-marker-outline',
    name: 'location',
    itemsProp: 'locations',
    localSelectedProp: 'localSelectedLocations',
    valueKey: 'locationId',
    labelKey: 'locationName',
  },
  time: {
    id: 5,
    title: 'bookingList.headerName.startEndTime',
    icon: 'mdi-clock-outline',
  },
  certification: {
    id: 6,
    title: 'bookingList.headerName.certification',
    icon: 'mdi-checkbox-blank-circle-outline',
    name: 'certification',
    itemsProp: 'certifications',
    localSelectedProp: 'localSelectedCertifications',
    valueKey: 'id',
    labelKey: 'name',
  },
  grade: {
    id: 7,
    title: 'bookingList.headerName.grade',
    icon: 'mdi-school-outline',
    name: 'grade',
    itemsProp: 'grades',
    localSelectedProp: 'localSelectedGrades',
    valueKey: 'id',
    labelKey: 'title',
  },
  replacing: {
    id: 8,
    title: 'bookingList.headerName.replacing',
    icon: 'mdi-face-woman-outline',
    name: 'replacing',
    itemsProp: 'replacing',
    localSelectedProp: 'localSelectedReplacing',
    valueKey: 'id',
    labelKey: ['firstName', 'lastName'],
  },
})
